import { useEffect, useRef, useState } from "react";
import { API_KEY_GOOGLE_MAP, C_colorAccent, C_colorPrimaryDark, C_colorTextoSinInfo, C_uniformeBlanco, C_uniformeGrisMedio, C_uniformeGrisOscuro, ID_MODULO_ADMIN_CANCHAS, ID_MODULO_ADMIN_CONFIGURACION, SEP_3, SEP_4, SEP_D_1, SEPARADOR_PARAMETROS_BD } from "../constantes/generales";
import { crearTabla, dividirLista, dividirListaNueva, formatearTexto, getConfirmacion, guardarDatoLocal, presentarError, presentarLog, quitarCharEspeciales, quitarTildes, recuperarDatoLocal, reportarError, setFlagUpdate, showMensajePantalla, valorLong, valorNumero } from "../helpers/funciones";
import { getDatos } from "../gestionDatos/getDatos";
import { GoogleMap, LoadScript, Marker, InfoWindow } from "@react-google-maps/api";

import ShowError from "../recVisual/ShowError";
import Loader from "../recVisual/Loader";


import ic_salir from '../recGraficos/ic_salir_w.png';
import ic_configura_blanco from '../recGraficos/ic_configura_blanco.png';
import ic_activo from '../recGraficos/ic_activo.png';
import ic_inactivo from '../recGraficos/ic_inactivo.png';
import ic_jugadorsinimagen from '../recGraficos/ic_jugadorsinimagen.png';
import ic_partido_verde from '../recGraficos/ic_partido_verde.png';
import ic_flecha_expandir from '../recGraficos/ic_flecha_expandir.png';
import ic_detalle_blanco from '../recGraficos/ic_detalle_blanco.png';
import ic_ubicacion_verde from '../recGraficos/ic_ubicacion_verde.png';
import ic_ok from '../recGraficos/ic_ok.png';
import ic_transparente from '../recGraficos/ic_transparente.png';
import ic_cancelar_gris from '../recGraficos/ic_cancelar_gris.png';
import ic_borrar_blanco from '../recGraficos/ic_borrar_blanco.png';


import DinamicoElementosTorneo from "../gestionVisual/DinamicoElementosTorneo";
import { useModal } from "../helpers/useModal";
import ModalFull from "../recVisual/ModalFull";
import Modal from "../recVisual/Modal";
import Mapa from "../recVisual/Mapa";




let ruta=recuperarDatoLocal("rutaRecursos");
const nomClase="Admin_Canchas_WB";
const idModulo=ID_MODULO_ADMIN_CANCHAS;

let idUser="";
let tipoUser=recuperarDatoLocal("tipoUser");
let idSede=recuperarDatoLocal("idSede");

let idCancha="";
let idTorneo="";
let esVentanaTorneo=false;

let nuevaCancha=false;


let titulo="";
let mensaje="";
let ventanaMensaje;

let posFinal;
let registroSel=-1;

let cancelarBusqueda=false;
let textoBuscar="";

let canchasSedeO = [];

let datosInicial = {
    tituloVentana:"",
    fotoUsuario:ic_jugadorsinimagen,
    rolUsuario:"",
    nomUsuario:"",
    nomEmpresa:"",
    nomSede:""
};

let matrizCampos=[
    {id: "NUMERO",  idx: 0, valor: "", ultValor:"", error: ""},
    {id: "NOMBRE",  idx: 1, valor: "", ultValor:"", error: ""},
    {id: "UBICACION",  idx: 2, valor: {lat: 0, lng:0}, ultValor:{lat:0, lng:0}, error: ""},
    {id: "UBICACION_SHOW",  idx: 3, valor: "", ultValor:"", error: ""},
    {id: "CANCHA_UNIDA",  idx: 4, valor: false, ultValor:false, error: ""},
    {id: "FILTRO_BUSQUEDA",  idx: 5, valor: "", ultValor:"", error: ""}
];

let ubicacionBase=[
    {id: "COLOMBIA",  idx: "57", lat: 4.646653, lng:-74.078625},
    {id: "ARGENTINA",  idx: "54", lat: -34.610909, lng:-58.452939},
    {id: "CHILE",  idx: "56", lat: -33.445448, lng:-70.660116},
    {id: "ECUADOR",  idx: "593", lat: -0.165993, lng:-78.479651},
    {id: "ESTADOS_UNIDOS", idx: "1", lat: 40.776326, lng:-73.961660},
    {id: "MEXICO",  idx: "52", lat: 19.430896, lng:-99.159677},
    {id: "PERU",  idx: "51", lat: -12.000232, lng:-77.062388}
];



let infoCanchaO = [];
let infoCancha = [];
let cancha = {
        indice: 0,
        idCancha:"",
        idsede:"",
        numero:"",
        horario:"",
        activo:"",
        tienePartidos:"",
        nombre:"",
        ubicacion:"",
        unida:""
    }
function crearInfoCancha(datos){    
    const nomFuncion="crearInfoCancha";

    try{        
        
    
        infoCanchaO = [];
        infoCancha = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , cancha);
            registro.indice=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idCancha=datos[i][j];
                if(j===1) registro.idsede=datos[i][j];
                if(j===2) registro.numero=datos[i][j];
                if(j===3) registro.horario=datos[i][j];
                if(j===4) registro.activo=datos[i][j];
                if(j===5) registro.tienePartidos=datos[i][j];
                if(j===6) registro.nombre=datos[i][j];
                if(j===7) registro.ubicacion=datos[i][j];
                if(j===8) registro.unida=datos[i][j];
            }

            infoCanchaO.push(registro);
            infoCancha.push(datos[i]);

        }


    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}


let infoTorneosO = [];
let infoTorneos = [];
let torneo = {
        indice: 0,
        idtorneo:"",
        escudo:"",
        nombre:"",
        activo:""
    }
function crearInfoTorneos(datos){    
    const nomFuncion="crearInfoTorneos";

    try{        
        
    
        infoTorneosO = [];
        infoTorneos = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , torneo);
            registro.indice=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idtorneo=datos[i][j];
                if(j===1) registro.escudo=datos[i][j];
                if(j===2) registro.nombre=datos[i][j];
                if(j===3) registro.activo=datos[i][j];
            }

            infoTorneosO.push(registro);
            infoTorneos.push(datos[i]);

        }


    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}


let infoCanchasUnidasO = [];
let infoCanchasUnidas = [];
let canchaU = {
        indice: 0,
        idCanchaUnida:"",
        idCancha:"",
        sinInfo:"",
    }
function crearInfoCanchasUnidas(datos){    
    const nomFuncion="crearInfoCanchasUnidas";

    try{        
        
    
        infoCanchasUnidasO = [];
        infoCanchasUnidas = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , canchaU);
            registro.indice=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idCanchaUnida=datos[i][j];
                if(j===1) registro.idCancha=datos[i][j];
                if(j===2) registro.sinInfo=datos[i][j];
            }

            infoCanchasUnidasO.push(registro);
            infoCanchasUnidas.push(datos[i]);

        }


    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }     

}

const Admin_Canchas = ({params="", definirModulo, modOrigen=0, paramOrigen=""}) => {
    const [esError, setEsError] = useState(0);
    const [loading, setLoading] = useState(false);
    const [showMensaje, setShowMensaje] = useState(false);
    const [msjModal, setMsjModal] = useState("");

    const refBusqueda=useRef(null);

    const [isOpenBusqueda, openBusqueda, closeBusqueda] = useModal(false);
    const [datosEncontrados, setDatosEncontrados] = useState([]);

    const [showFullUS, setShowFullUS] = useState(true);
    const [nuevaCanchaUS, setNuevaCanchaUS] = useState(true);
    const [canchaActivaUS, setCanchaActivaUS] = useState(false);
    const [esCanchaUnidaUS, setEsCanchaUnidaUS] = useState(false);
    const [tienePartidosUS, setTienePartidosUS] = useState(false);

    const [torneosCanchaUS, setTorneosCanchaUS] = useState([]);
    const [canchasUnidasUS, setCanchasUnidasUS] = useState([]);

    const [arrCampos, setArrCampos] = useState(matrizCampos);
    const [datosMod, setDatosMod] = useState(datosInicial);


    const [isOpenMapa, openMapa, closeMapa] = useModal(false);
    const [zoomUS, setZoomUS] = useState(11);


    var respuesta = {
                datos: "",
                exito: false,
                conectado: false,
                hayDatos: false,
                mensaje: ''
            }
        
    useEffect(() => {
        const nomFuncion="useEffect";
        
        try{       

            nuevaCancha=true;
            let actualizar=false;
            let info=dividirLista(params,SEP_4,2);
        
            setNuevaCanchaUS(true);
            setCanchaActivaUS(false);

            canchasSedeO=JSON.parse(recuperarDatoLocal("infoCanchasSede"));
            infoCanchasUnidasO = [];
            infoCanchasUnidas = [];

            if(params!==""){
                idCancha=info[0];
                idTorneo=info[1];

                if(idCancha!=="-1"){
                    nuevaCancha=false;
                    actualizar=true;

                    setNuevaCanchaUS(false);
                }

                if(valorNumero(idTorneo)>0) setShowFullUS(false);
            }

 

            if(!nuevaCancha){
                BD_solicitarDatos("INFO_ADMIN_CANCHA");  
            }  

            generarDatosPresentar();
        
        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }     
                
        
    }, [params]);        
    
    
    const BD_solicitarDatos = (tipoDatos, params) => {
    let nomFuncion="BD_solicitarDatos"; 
        
    try{
                    let actualizar=true;
                    let SEP=SEPARADOR_PARAMETROS_BD;
                    let paramQuery="";
                    let tipoConsulta="";
                    let funcion="";
                    let consulta="";
                    let zonaHoraria="0";
                    let mostrarError=true;
                    let mostrarProcesando=true;
        
                    let codigoFinal="";
                    
                    if(actualizar){      
                        
                        zonaHoraria="" + valorNumero(recuperarDatoLocal("zonahoraria"));
        
                        if(tipoDatos==="INFO_ADMIN_CANCHA"){
                            tipoConsulta="consultarTabla";
                            funcion="getListasDetalleCancha";
                            consulta="INFO_ADMIN_CANCHA";
                            
                            paramQuery= idCancha;
        
                        } else if(tipoDatos==="CREAR_NUEVA_CANCHA"){
                            tipoConsulta="ejecutarSQL";
                            funcion="actualizarCancha";
                            consulta="CREAR_NUEVA_CANCHA";

                            let numero=arrCampos[0].valor;
                            let txtHorarios="LU 00-24|MA 00-24|MI 00-24|JU 00-24|VI 00-24|SA 00-24|DO 00-24";
                            let nombre=arrCampos[1].valor;
                            let ubicacion="";
                            if(arrCampos[3].valor!=="") ubicacion=arrCampos[2].valor.lat + ";" + arrCampos[2].valor.lng;
                            let esUnida="0";
                            if(esCanchaUnidaUS) esUnida="1";
                            let idsCanchasUnidas="";
                            if(esUnida==="1"){
                                for(let i=0;i<canchasUnidasUS.length;i++){
                                    if(idsCanchasUnidas==="") idsCanchasUnidas=canchasUnidasUS[i].idCancha;
                                    else idsCanchasUnidas=idsCanchasUnidas + ", " + canchasUnidasUS[i].idCancha;
                                }
                            }
                            if(idsCanchasUnidas==="") esUnida="0";                            

                            let idTorneoFinal="0";

                            if(idTorneo!=="") idTorneoFinal=idTorneo;

                            paramQuery= idSede + SEP + numero + SEP + txtHorarios + SEP + nombre + SEP + ubicacion + SEP + esUnida + SEP + idsCanchasUnidas + SEP + idTorneoFinal;
                       
                        } else if(tipoDatos==="ASOCIAR_CANCHA_TORNEO"){
                            tipoConsulta="ejecutarSQL";
                            funcion="actualizarCancha";
                            consulta="ASOCIAR_CANCHA_TORNEO";                            

                            paramQuery= idTorneo + SEP + idCancha;
                        } else if(tipoDatos==="RETIRAR_CANCHA_UNIDA"){
                            tipoConsulta="ejecutarSQL";
                            funcion="actualizarCancha";
                            consulta="RETIRAR_CANCHA_UNIDA";    
                            mostrarProcesando=false;                        

                            let idCanchaUnida=canchasSedeO[registroSel].idCancha;

                            paramQuery= idCancha + SEP + idCanchaUnida;
                        } else if(tipoDatos==="RETIRAR_TODAS_LAS_CANCHAS_UNIDAS"){
                            tipoConsulta="ejecutarSQL";
                            funcion="actualizarCancha";
                            consulta="RETIRAR_TODAS_LAS_CANCHAS_UNIDAS";    
                            mostrarProcesando=false;                        

                            paramQuery= idCancha ;
                        } else if(tipoDatos==="INCLUIR_CANCHA_UNIDA"){
                            tipoConsulta="ejecutarSQL";
                            funcion="actualizarCancha";
                            consulta="INCLUIR_CANCHA_UNIDA";    
                            mostrarProcesando=false;                        

                            let idCanchaUnida=params;

                            paramQuery= idCancha + SEP + idCanchaUnida;
                        } else if(tipoDatos==="ACTUALIZAR_CAMPOS_CANCHA"){
                                            tipoConsulta="ejecutarSQL";
                                            funcion="actualizarCancha";
                                            consulta="ACTUALIZAR_CAMPOS_CANCHA";
                                            mostrarProcesando=false;
                        
                                            let txtParejasUdt="";
                                            let parejas=params.split(SEP_D_1);
                                            for(let i=0;i<parejas.length;i++){
                                                let columnas=parejas[i].split(SEP_3);
                                                let valor="";
                                                if(columnas.length===2) valor=columnas[1].trim();
                        
                                                if(valor==="NULL"){
                                                    if(txtParejasUdt==="") txtParejasUdt=columnas[0] + "=NULL ";
                                                    else txtParejasUdt=txtParejasUdt + ", " + columnas[0] + "=NULL ";
                                                }
                                                else{
                                                    if(txtParejasUdt==="") txtParejasUdt=columnas[0] + "='" + valor + "' ";
                                                    else txtParejasUdt=txtParejasUdt + ", " + columnas[0] + "='" + valor + "' ";
                                                }
                                            }
                                            
                                            paramQuery= idCancha + SEP + txtParejasUdt;
                        } else if(tipoDatos==="BORRAR_CANCHA"){
                            tipoConsulta="ejecutarSQL";
                            funcion="actualizarCancha";
                            consulta="BORRAR_CANCHA";                         

                            paramQuery= idCancha;
                        } 
                        
                        if(mostrarProcesando) setLoading(true);
        
                        getDatos()
                        .get(tipoConsulta,funcion,consulta,paramQuery,zonaHoraria)
                        .then((res) => {
                            nomFuncion="BD_solicitarDatos.respuesta"; 
        
                            try{
                                respuesta=res;
                                if (respuesta.exito) {
                                    if(tipoDatos==="INFO_ADMIN_CANCHA"){
                                        presentarLog(nomClase + " - SOLICITA_DATOS"); 
        
                                        //guardarDatoLocal("ultAcceso" + idModulo,Date.now());
                                        //guardarDatoLocal("datos" + idModulo, respuesta.datos);
                
                                        crearInfoCancha(crearTabla(respuesta.datos,"1")); 
                                        crearInfoTorneos(crearTabla(respuesta.datos,"2")); 
                                        crearInfoCanchasUnidas(crearTabla(respuesta.datos,"3")); 
                                        //setDatosCargadosBusqueda(true);

                                        procesarInfoRecibida();
        
                                    } else if(tipoDatos==="CREAR_NUEVA_CANCHA"){

                                        if(valorNumero(respuesta.datos)>0){
                                            idCancha=respuesta.datos;

                                            titulo="";
                                            mensaje="Información actualizada con éxito";
                                            ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");

                                            guardarDatoLocal("ultAccesoICS" + idSede,"");
                                            //setFlagUpdate(true);

                                            if(!showFullUS)
                                                definirModulo("CANCHA_CREADA_CON_EXITO", idCancha);                                              
                                            else
                                                salir();
                                        }  
                                        else{
                                            titulo="Cancha NO Creada";
                                            mensaje="La cancha no pudo crearse, intente nuevamente o reporte el problema.";
                                            ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"ERROR","MEDIA");
                                        }      
                                    } else if(tipoDatos==="RETIRAR_CANCHA_UNIDA"){

                                        titulo="";
                                        mensaje="Información actualizada con éxito";
                                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");

                                        guardarDatoLocal("ultAccesoICS" + idSede,"");
                                         
                                    } else if(tipoDatos==="RETIRAR_TODAS_LAS_CANCHAS_UNIDAS"){

                                        titulo="";
                                        mensaje="Información actualizada con éxito";
                                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");

                                        guardarDatoLocal("ultAccesoICS" + idSede,"");
                                         
                                    } else if(tipoDatos==="INCLUIR_CANCHA_UNIDA"){

                                        titulo="";
                                        mensaje="Información actualizada con éxito";
                                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");

                                        guardarDatoLocal("ultAccesoICS" + idSede,"");
                                         
                                    } else if(tipoDatos==="ACTUALIZAR_CAMPOS_CANCHA"){
                                                                    
                                                                    let tempArreglo=JSON.parse(JSON.stringify(arrCampos));
                                        
                                                                    let llaves=params.split(SEP_D_1);
                                                                    for(let i=0;i<llaves.length;i++){
                                                                        let columnas=llaves[i].split(SEP_3);
                                                                        if(columnas.length===2){
                                                                            if(columnas[0]==="nombre") {
                                                                                infoCanchaO[0].nombre=columnas[1];
                                                                                tempArreglo[1].valor=columnas[1];
                                                                                tempArreglo[1].ultValor=columnas[1];
                                                                                setFlagUpdate(true);
                                                                            }
                                                                            else if(columnas[0]==="ubicacion"){  
                                                                                let ubc=dividirLista(columnas[1],";",2);
                                                                                infoCanchaO[0].ubicacion=columnas[1];
                                                                                tempArreglo[2].valor.lat=valorLong(ubc[0]);
                                                                                tempArreglo[2].valor.lng=valorLong(ubc[1]);
                                                                                tempArreglo[2].ultValor=tempArreglo[2].valor;
                                                                                
                                                                                tempArreglo[3].valor="Latitud: " + ubc[0] + "\nLongitud: " + ubc[1];
                                                                                tempArreglo[3].ultValor=tempArreglo[3].valor;
                                                                                //setFlagUpdate(true);
                                                                            }
                                                                            else if(columnas[0]==="unida")  {
                                                                                infoCanchaO[0].unida=columnas[1];
                                                                                tempArreglo[4].valor=columnas[1]==="1" ? true : false;
                                                                                tempArreglo[4].ultValor=tempArreglo[4].valor;

                                                                                if(columnas[1]==="1") setEsCanchaUnidaUS(true);
                                                                                else setEsCanchaUnidaUS(false);
                                                                            }
                                                                            else if(columnas[0]==="activo")  {
                                                                                infoCanchaO[0].activo=columnas[1];

                                                                                if(columnas[1]==="1") setCanchaActivaUS(true);
                                                                                else setCanchaActivaUS(false);
                                                                            }
                                                                            
                                                                        }
                                                                    }
                                        
                                                                    setArrCampos(tempArreglo);       
                                                                    guardarDatoLocal("ultAccesoICS" + idSede,"");

                                                                    titulo="";
                                                                    mensaje="Información actualizada con éxito";
                                                                    ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");
                                                                    
                                    
                                    } else if(tipoDatos==="BORRAR_CANCHA"){

                                        titulo="";
                                        mensaje="Información actualizada con éxito";
                                        ventanaMensaje=showMensajePantalla(titulo,mensaje,setShowMensaje,null,"EXITO","BAJA");

                                        guardarDatoLocal("ultAccesoICS" + idSede,"");
                                        salir();
                                         
                                    }                                       
                    
                                } else {
                                    if(respuesta.conectado){
                                        reportarError( nomClase, nomFuncion, respuesta.mensaje, "");
                                        if(mostrarError) setEsError(1);
                                    } 
                                    else{    
                                        presentarError(nomClase,nomFuncion,respuesta.mensaje,"");                        
                                        setEsError(2);
                                    }                       
                                }
        
                            }catch(err){
                                reportarError( nomClase, nomFuncion, "", err);
                            } 
                            
                
                            setLoading(false);
                            
                        });
                    }
                    
                   
        
                }catch(err){
                    reportarError( nomClase, nomFuncion, "", err);
                }  
            } 


    const generarDatosPresentar = () => {
        let nomFuncion="generarDatosPresentar";

        try{
  
            let datosTemp=JSON.parse(JSON.stringify(datosMod));   
            let tempArreglo=JSON.parse(JSON.stringify(arrCampos));               

            datosTemp.nomUsuario=recuperarDatoLocal("nomUsuario");
            datosTemp.nomEmpresa=recuperarDatoLocal("nomEmpresa");
            datosTemp.nomSede=recuperarDatoLocal("nomSede");
            datosTemp.fotoUsuario=recuperarDatoLocal("fotoUsuario");
            if(datosTemp.fotoUsuario!=="") datosTemp.fotoUsuario= ruta + datosTemp.fotoUsuario;
            else datosTemp.fotoUsuario=ic_jugadorsinimagen;

            datosTemp.tituloVentana="Administración Canchas";
            datosTemp.rolUsuario="Administrador:";  

            setDatosMod(datosTemp);

            //Procesar Canchas Sede
            let numCancha=0;
            for(let i=0;i<canchasSedeO.length;i++){
                let numTemp=valorNumero(canchasSedeO[i].numero);
                if(numTemp>numCancha) numCancha=numTemp;
            }

            numCancha++;
            tempArreglo[0].valor=numCancha;
            tempArreglo[0].ultValor=numCancha;

            //Establecer ubicacion
            let ubicacion=buscarUbicacion(idSede);
            tempArreglo[2].valor.lat=ubicacion.lat;
            tempArreglo[2].valor.lng=ubicacion.lng;

            setArrCampos(tempArreglo);
            setZoomUS(6);


        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        } 

    }

    const procesarInfoRecibida = () => {
        let nomFuncion="procesarInfoRecibida";

        try{

            if(!nuevaCancha){
                let tempArreglo=JSON.parse(JSON.stringify(arrCampos));      

                //CANCHA ACTIVA/INACTIVA
                if(infoCanchaO[0].activo==="1") setCanchaActivaUS(true);
                else setCanchaActivaUS(false);

                if(infoCanchaO[0].tienePartidos!=="0") setTienePartidosUS(true);
                else setTienePartidosUS(false);
                
                tempArreglo[0].valor=infoCanchaO[0].numero;
                tempArreglo[0].ultValor=infoCanchaO[0].numero;
                tempArreglo[1].valor=infoCanchaO[0].nombre;
                tempArreglo[1].ultValor=infoCanchaO[0].nombre;

                if(infoCanchaO[0].ubicacion!==""){
                    setZoomUS(16);
                    let datos=dividirLista(infoCanchaO[0].ubicacion,";",2);

                    tempArreglo[2].valor.lat=valorLong(datos[0]);
                    tempArreglo[2].valor.lng=valorLong(datos[1]);

                    if(tempArreglo[2].valor.lat==0 && tempArreglo[2].valor.lng==0) setZoomUS(2);
                    
                    tempArreglo[2].ultValor.lat=tempArreglo[2].valor.lat;
                    tempArreglo[2].ultValor.lng=tempArreglo[2].valor.lng;

                    tempArreglo[3].valor="Latitud: " + tempArreglo[2].valor.lat + "\nLongitud: " + tempArreglo[2].valor.lng;
                    tempArreglo[3].ultValor=tempArreglo[3].valor;
                }
                else{
                    setZoomUS(11);
                    let ubi=buscarUbicacion(idSede);
                    tempArreglo[2].valor.lat=ubi.lat;
                    tempArreglo[2].valor.lng=ubi.lng;
                    tempArreglo[2].ultValor.lat=ubi.lat;
                    tempArreglo[2].ultValor.lng=ubi.lng;
                }

                //ES CANCHA UNIDA
                if(infoCanchaO[0].unida==="1"){
                    tempArreglo[4].valor=true;
                    tempArreglo[4].ultValor=true;

                    setEsCanchaUnidaUS(true);
                }

                setArrCampos(tempArreglo);
            }
            

            //ARMAR ARREGLO DE TORNEOS ACTIVOS
            let tempTorneos=[];
            for(let i=0;i<infoTorneosO.length;i++){
                tempTorneos.push(infoTorneosO[i]);
            }

            setTorneosCanchaUS(tempTorneos);

            //ARMAR ARREGLO CANCHAS UNIDAS
            let tempCanchasU=[];
            for(let i=0;i<infoCanchasUnidasO.length;i++){
                for(let j=0;j<canchasSedeO.length;j++){
                    if(canchasSedeO[j].idCancha===infoCanchasUnidasO[i].idCancha){
                        tempCanchasU.push(canchasSedeO[j]);
                        j=canchasSedeO.length;
                    }
                }                
            }

            setCanchasUnidasUS(tempCanchasU);


        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        } 

    }

    const buscarUbicacion = (sede) => {
            let nomFuncion="buscarUbicacion"; 

            let respuesta={lat:0, lng:0};
    
            try{
                let encontro=false;

                for(let i=0;i<ubicacionBase.length; i++){
                    if(ubicacionBase[i].idx===sede){
                        respuesta.lat=ubicacionBase[i].lat;
                        respuesta.lng=ubicacionBase[i].lng;
                        i=ubicacionBase.length;
                        encontro=true;
                    }
                }

                if(!encontro){                    
                    respuesta.lat=ubicacionBase[0].lat;
                    respuesta.lng=ubicacionBase[0].lng;
                    
                }

    
            }catch(err){
                reportarError( nomClase, nomFuncion, "", err);
            }      
            
            return respuesta;
            
        }

    
    const abrirVentanaBusqueda = (numC) => {
            let nomFuncion="abrirVentanaBusqueda";
    
            try{
                textoBuscar="";
                let tempArreglo=JSON.parse(JSON.stringify(arrCampos));
                tempArreglo[5].valor="";
                tempArreglo[5].error="";
                setArrCampos(tempArreglo);
    
                cancelarBusqueda=false;
    
                setDatosEncontrados([]);            
                
                openBusqueda();
    
                if (refBusqueda.current)  refBusqueda.current.focus();            
                
                textoBuscar="";
                buscarTexto();
    
            }catch(err){
                reportarError( nomClase, nomFuncion, "", err);
            }  
        }

    const buscarTexto = () => {
            let nomFuncion="buscarTexto";
    
            try{
                cancelarBusqueda=false;
                let regPagina=20;
                let tempDatosEncontrados=[];
                let llavesIncluidas=[];
    
                   
    
                if(true){
                    
                    let datos=[];
                    let datosTI=false;

                    datos=JSON.parse(JSON.stringify(canchasSedeO));
                      
                    if(datos.length>0) datosTI=true;
        
                    let total=0;
                    let texto="", textoBuscado="";
                    
                    textoBuscado=textoBuscar;
                    textoBuscado=textoBuscado.replaceAll("+","");
                    textoBuscado=quitarTildes(textoBuscado).toUpperCase();
    
                    if(datosTI){
                            let i;
                            cancelarBusqueda=false;
    
                            for(i=0;i<datos.length;i++){
                                if(cancelarBusqueda) return;
                              
                                if(!cancelarBusqueda){
                                    let incluir=false;                                
                                    
                                    if(datos[i].idCancha!==idCancha){                                        
                                        texto=datos[i].nomBusqueda;
                                        if(datos[i].activo==="1" && (textoBuscado==="" || texto.includes(textoBuscado))) incluir=true;
                                        if(!incluir && datos[i].activo==="1" && datos[i].nombreNum.includes(textoBuscado)) incluir=true;
                                    }                                 
    
    
                                    if(incluir){                                    
                                       
                                        let llave="";
                                        llave=datos[i].idCancha;
    
                                        let correcto=true;
                                        for(let j=0;j<llavesIncluidas.length;j++){
                                                if(llavesIncluidas[j]===llave){
                                                    correcto=false;
                                                    j=llavesIncluidas.length;
                                                }
                                        }
    
                                        if(correcto){
                                            correcto=!yaEstaInscrito(llave);
                                        }
                                            
                                        if(correcto){
                                                tempDatosEncontrados.push(datos[i]);
                                                llavesIncluidas.push(llave);
                                                total++;
                                        }
                                        
    
                                        if(total>=regPagina) i=datos.length;
                                    }
    
                                }
                                else i=datos.length;
    
                            }
    
                    }
    
                       
    
                    if(!cancelarBusqueda) setDatosEncontrados(tempDatosEncontrados);  
    
                }
                else setDatosEncontrados(tempDatosEncontrados);
    
    
    
            }catch(err){
                reportarError( nomClase, nomFuncion, "", err);
            } 
    
        }

    const yaEstaInscrito = (id) => {
            let nomFuncion="yaEstaInscrito";
    
            let respuesta=false;
            try{
    
                for(let i=0;i<infoCanchasUnidasO.length;i++){
                        if(infoCanchasUnidasO[i].idCancha===id){
                            respuesta=true;
                            i=infoCanchasUnidasO.length;                       
                        }
                    }
                
    
            }catch(err){
                reportarError( nomClase, nomFuncion, "", err);
            }  
    
            return respuesta;
        }


    const validarCampo = (e, campo, maxlen) => {
            let nomFuncion="validarCampo"; 
    
            try{
                let newValor = e.target.value;
                if(maxlen!==null && newValor.length>maxlen) newValor=newValor.substring(0,maxlen);
    
                let tempArreglo=JSON.parse(JSON.stringify(arrCampos));
    
                if(campo==="NOMBRE"){  
                    tempArreglo[1].valor=newValor;   
                    
                    setArrCampos(tempArreglo);  
                } else if(campo==="APELLIDO"){  
                    tempArreglo[1].error=matrizCampos[1].error;
                    
                    tempArreglo[1].valor=newValor;  
                    if(newValor.length>=3) tempArreglo[1].error="";     
                    
                    setArrCampos(tempArreglo);  
                } else if(campo==="FILTRO_BUSQUEDA"){

                    tempArreglo[5].error="";                
                    tempArreglo[5].valor=newValor; 

                    setArrCampos(tempArreglo);  
                    textoBuscar=newValor;
                    
                    cancelarBusqueda=true;
                    buscarTexto();               

                }       
                        
                
    
            }catch(err){
                reportarError( nomClase, nomFuncion, "", err);
            }         
            
        }

    
    const clickGenerico = (donde, params=null) => {
        let nomFuncion="clickGenerico"; 

        try{
            
            let tempArreglo=null;
            
            switch(donde) {
                
                case "ACTUALIZAR_UBICACION":
                    posFinal=params;

                    break;
                case "CLICK_ACEPTAR_SELUBICACION":
                    closeMapa();
                    tempArreglo=JSON.parse(JSON.stringify(arrCampos));
                    tempArreglo[2].valor=posFinal;
                    tempArreglo[3].valor="Latitud: " + posFinal.lat + "\nLongitud: " + posFinal.lng;

                    setZoomUS(16);
                    setArrCampos(tempArreglo);

                    if(!nuevaCancha){
                        let nuevoDato=posFinal.lat + ";" + posFinal.lng;
                        let txtActualizar="ubicacion" + SEP_3 + nuevoDato;
                        if(posFinal!==arrCampos[2].ultValor) BD_solicitarDatos("ACTUALIZAR_CAMPOS_CANCHA", txtActualizar);
                    }
                
                    break;
                case "CLICK_CREAR_NUEVA_CANCHA":
                    titulo="CONFIRMAR CANCHA";
                    mensaje="Esta acción creará una nueva Cancha de acuerdo a los datos y parametros suministrados.\n\nEsta de acuerdo?";
                    ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"ACEPTAR_CREAR_NUEVA_CANCHA");


                    break;
                case "ACEPTAR_CREAR_NUEVA_CANCHA":
                    setShowMensaje(false);

                    BD_solicitarDatos("CREAR_NUEVA_CANCHA");

                    break;
                case "CLICK_RETIRAR_CANCHA_UNIDA":
                    registroSel=params;

                    if(nuevaCancha){
                        canchasSedeO[registroSel].borrado="1";
                        let pos=-1;
                        for(let i=0;i<infoCanchasUnidasO.length;i++){
                            if(infoCanchasUnidasO[i].idCancha===canchasSedeO[registroSel].idCancha){
                                pos=i;
                                i=infoCanchasUnidasO.length;
                            }
                        }
                        if(pos>=0) infoCanchasUnidasO.splice(pos, 1);

                        procesarInfoRecibida();
                    }else{
                        titulo="CONFIRMAR RETIRO";
                        mensaje="Esta acción retirará la cancha seleccionada de las canchas unidas para formar la cancha principal.\n\nEsta de acuerdo?";
                        ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"ACEPTAR_RETIRAR_CANCHA_UNIDA");
                    }                    

                    break;
                case "ACEPTAR_RETIRAR_CANCHA_UNIDA":
                    setShowMensaje(false);

                    canchasSedeO[registroSel].borrado="1";
                    let pos=-1;
                    for(let i=0;i<infoCanchasUnidasO.length;i++){
                        if(infoCanchasUnidasO[i].idCancha===canchasSedeO[registroSel].idCancha){
                            pos=i;
                            i=infoCanchasUnidasO.length;
                        }
                    }
                    if(pos>=0) infoCanchasUnidasO.splice(pos, 1);

                    procesarInfoRecibida();

                    if(!nuevaCancha) BD_solicitarDatos("RETIRAR_CANCHA_UNIDA");

                    break;
                case "CAMBIAR_CHECK_CANCHA_UNIDA":
                    
                    if(!params.target.checked && canchasUnidasUS.length>0){
                        titulo="CONFIRMAR RETIRO";
                        mensaje="Esta acción retirará TODAS las canchas unidas para formar la cancha principal.\n\nEsta de acuerdo?";
                        ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"ACEPTAR_CAMBIAR_CHECK_CANCHA_UNIDA");
                    }
                    else {
                        let estado=params.target.checked;
                        if(estado) setEsCanchaUnidaUS(true);
                        else setEsCanchaUnidaUS(false);

                        if(!nuevaCancha){
                            let nuevoDato=estado ? "1" : "0";
                            let txtActualizar="unida" + SEP_3 + nuevoDato;
                            if(estado!==arrCampos[4].ultValor) BD_solicitarDatos("ACTUALIZAR_CAMPOS_CANCHA", txtActualizar);
                        }
                    }

                    break;
                case "ACEPTAR_CAMBIAR_CHECK_CANCHA_UNIDA":
                    setShowMensaje(false);
                    setEsCanchaUnidaUS(false);

                    infoCanchasUnidasO=[]; 
                    
                    if(!nuevaCancha){
                        infoCanchaO[0].unida="0";

                        BD_solicitarDatos("RETIRAR_TODAS_LAS_CANCHAS_UNIDAS");

                        let nuevoDato="0";
                        let txtActualizar="unida" + SEP_3 + nuevoDato;
                        if(false!==arrCampos[4].ultValor) BD_solicitarDatos("ACTUALIZAR_CAMPOS_CANCHA", txtActualizar);
                    }   
                    
                    procesarInfoRecibida();

                    break;  
                case "LIMPIAR_FILTRO_BUSQUEDA":
                    tempArreglo=JSON.parse(JSON.stringify(arrCampos));
                    tempArreglo[5].valor="";
                    tempArreglo[5].error="";
                    setArrCampos(tempArreglo);

                    textoBuscar="";
                
                    if (refBusqueda.current)  refBusqueda.current.focus();
                    cancelarBusqueda=true;
                    buscarTexto(); 

                    break;     
                case "CLICK_INCLUIR_CANCHA_SEDE":
                    let idx=params;

                    let registro=Object.assign({} , canchaU);
                    registro.idCanchaUnida=idCancha;
                    registro.idCancha=canchasSedeO[idx].idCancha;
                    canchasSedeO[idx].borrado="0";

                    infoCanchasUnidasO.push(registro);
                    procesarInfoRecibida();
                    buscarTexto();

                    if(!nuevaCancha) BD_solicitarDatos("INCLUIR_CANCHA_UNIDA", canchasSedeO[idx].idCancha);
                    
                    break;
                case "MODIFICAR_ESTADO_CANCHA":
                        titulo="CAMBIO ESTADO";
                        if(canchaActivaUS) mensaje="Esta acción INACTIVARÁ la cancha, por lo que no estará disponible para ningún torneo y no podrá programar partidos en esta cancha.\n\nEsta de acuerdo?";
                        else mensaje="Esta acción ACTIVARÁ la cancha, habilitándola para asignar en sus torneos y programar partidos en ella.\n\nEsta de acuerdo?";
                        ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"ACEPTAR_MODIFICAR_ESTADO_CANCHA");

                    break;
                case "ACEPTAR_MODIFICAR_ESTADO_CANCHA":
                    setShowMensaje(false);

                    if(!nuevaCancha){
                            let nuevoDato=!canchaActivaUS ? "1" : "0";
                            let txtActualizar="activo" + SEP_3 + nuevoDato;
                            BD_solicitarDatos("ACTUALIZAR_CAMPOS_CANCHA", txtActualizar);
                        }

                    setCanchaActivaUS(!canchaActivaUS)

                    break;
                case "CLICK_BORRAR_CANCHA":
                        titulo="CONFIRMAR BORRADO";
                        mensaje="Esta acción BORRARÁ esta cancha de las canchas configuradas en su Sede.\n\nEsta de acuerdo?";
                        ventanaMensaje=getConfirmacion(titulo,mensaje,setShowMensaje,null,clickGenerico,"ACEPTAR_BORRAR_CANCHA");

                    break;
                case "ACEPTAR_BORRAR_CANCHA":
                    setShowMensaje(false);

                    BD_solicitarDatos("BORRAR_CANCHA");                    

                    break;
                case "SALE_NOMBRE":
                    if(!nuevaCancha){
                        if(arrCampos[1].error===""){
                                        let nuevoDato=quitarCharEspeciales(arrCampos[1].valor);
                                        nuevoDato=formatearTexto(nuevoDato,2);
                                        let txtActualizar="nombre" + SEP_3 + nuevoDato;
                                        if(nuevoDato!==arrCampos[1].ultValor) BD_solicitarDatos("ACTUALIZAR_CAMPOS_CANCHA", txtActualizar);
                        }
                    }
                                    
                    break;
                default:
                    break;

            }

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  
    } 


    const salir = () => {        
        definirModulo(0,idModulo,params,modOrigen,"CANCHAS");   
    }


    return (
        <>

            {/* VENTANA PRESENTAR MAPA */}
            {isOpenMapa && (
                <Modal isOpen={isOpenMapa} closeModal={closeMapa} isCancelable={true} clickAceptar={() => clickGenerico("CLICK_ACEPTAR_SELUBICACION")}> 
                    <div style={{width:"1000px", height:"70vh", minWidth:"300px", maxWidth:"100%", minHeight:"400px", maxHeight:"100%"}}>
                        <Mapa zoom={zoomUS} center={arrCampos[2].valor} letMoveCentro={true} posFinal={posFinal} updatePosicion={clickGenerico}/>
                    </div>                       
                </Modal>
            )}

            {/* VENTANA BUSQUEDAS */}
            {isOpenBusqueda && (
                <Modal isOpen={isOpenBusqueda} closeModal={closeBusqueda} titulo={"Incluir Canchas"}  isCancelable={true} txtCancelar="" txtAceptar="" >
                <div style={{margin:"10px", minHeight:"300px", maxHeight:"500px", maxWidth:"400px", fontSize:"16px", color:C_uniformeGrisOscuro}}>                    

                    <div style={{textAlign:"center", fontSize:"14px"}}>{"Busque y seleccione la o las Canchas de la sede que unirá para formar la cancha actual."}</div>
                    
                    <div style={{marginBlock:"20px", marginLeft:"20px", display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                        <input autoFocus ref={refBusqueda} type="text" value={arrCampos[5].valor} className='IP_entradas' style={{width:"100%"}} placeholder="" onChange={(e) => validarCampo(e, "FILTRO_BUSQUEDA", 20)}/>
                        <img className='IM_imgIcono16' src={ic_cancelar_gris} alt='' style={{paddingLeft:"10px", paddingRight:"15px", paddingBlock:"5px", cursor:"pointer"}} onClick={() => clickGenerico("LIMPIAR_FILTRO_BUSQUEDA")}/> 
                    </div>
                   

                    <div style={{height:"250px", overflow:"auto"}}>
                            {datosEncontrados.length===0 && arrCampos[5].valor!=="" && (
                                <div style={{color:C_colorTextoSinInfo, whiteSpace:"pre-wrap", marginTop:"10px"}}>
                                    {"No hay registros que coincidan con el dato buscado."}
                                </div>
                            )} 

                            {datosEncontrados.length>0 && (<>
                                {(datosEncontrados.map((reg, index) => (<DinamicoElementosTorneo key={index} registro={index} numRegistro={index+1} tipoLista={"Busqueda_Incluir_Cancha_Sede"} datos={reg} definirModulo={clickGenerico} incluirLinea={false} />))  )}     
                            </>)} 

                            {arrCampos[5].valor==="" && (
                                <div style={{color:C_colorTextoSinInfo, whiteSpace:"pre-wrap", marginBlock:"10px"}}>                                    
                                    {("Ingrese el nombre de la Cancha a buscar.")}
                                </div>
                            )}  

                                                       
                    </div>  
                     

                </div> 
                </Modal>
            )}

            {showMensaje && (ventanaMensaje)}

            {showFullUS && (<>
                {/* BARRA TITULO VENTANA */}
                <div className="CT_zonaFija">
                    <div className="CT_encabezado" style={{width:"100%"}}>
                        <div className="CT_elementoEncabezado" onClick={salir}><img src={ic_salir} className="IM_imgIcono24" alt="" style={{padding: "8px", cursor:"pointer"}} />  </div>
                        <div className="CT_elementoEncabezado"><img className="IM_imgRedondeada36" height="36px" width="36px" src={ic_configura_blanco} alt="" /></div>
                        <div className="CT_elementoEncabezado"><p className="TX_unaSolaLinea">{datosMod.tituloVentana}</p></div>
                    </div>
                </div>

                {/* ZONA INFO USUARIO, EMPRESA Y SEDE */}
                <div style={{paddingTop:"50px"}}>
                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", background:C_colorPrimaryDark, color:C_uniformeBlanco}}>
                        <img className="IM_imgRedondeada46" src={datosMod.fotoUsuario} alt="" style={{padding:"8px"}}/>
                        <div style={{flex:"1", fontSize:"14px", textAlign:"left", color: C_colorAccent }}>
                            <div className="TX_unaSolaLinea2"><span style={{marginRight:"10px"}}>{datosMod.rolUsuario}</span><span style={{color:C_uniformeBlanco}}>{datosMod.nomUsuario}</span></div>
                            <div className="TX_unaSolaLinea2"><span style={{marginRight:"10px"}}>{"Empresa:"}</span><span style={{color:C_uniformeBlanco}}>{datosMod.nomEmpresa}</span></div>
                            <div className="TX_unaSolaLinea2"><span style={{marginRight:"10px"}}>{"Sede:"}</span><span style={{color:C_uniformeBlanco}}>{datosMod.nomSede}</span></div>
                        </div> 
                    </div>     
                </div>
            </>)}

            
            
                          

            {!loading && esError===0 && (<>
                <div style={{margin: "10px", paddingBottom:"60px"}}>  
                                     
                    {/* TITULO DEL MODULO - ESTADO */} 
                    <div className="CT_contenedorTitulo" style={{marginBottom:"0px"}}>
                        {showFullUS && (
                            <img className='IM_imgIcono28' src={ic_flecha_expandir} alt='' style={{padding:"10px", cursor:"pointer"}} onClick={() => {salir()}}/>   
                        )}
                            
                            <img className='IM_imgRedondeada36' src={ic_partido_verde} alt='' style={{marginInline:"10px"}}/>   
                            <div style={{flex:"1", fontSize:"18px", fontWeight:"bold", textAlign:"left"}}>{nuevaCanchaUS ? "Nueva Cancha" : ("Cancha No. " + arrCampos[0].valor)}</div>  
                            <img className='IM_imgIcono28' src={canchaActivaUS ? ic_activo : ic_inactivo} alt='' style={{marginInline:"10px"}}/>    
                    </div>

                    {
                    /*}
                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"right"}}>
                            <div>
                                <div style={{fontSize:"10px", color:C_uniformeGrisOscuro}}>Borrar</div>
                                <img className='IM_imgIcono28' src={ic_borrar_rojo} alt='' style={{marginInline:"10px"}}/>   
                            </div>
                            <div>
                                <div style={{fontSize:"10px", color:C_uniformeGrisOscuro}}>Estado</div>
                                <div style={{display:"flex", justifyContent:"center", alignItems:"center", height:"20px", marginRight:"0px", marginBottom:"0px"}}>                                    
                                    <label className="switch">
                                        <input disabled={nuevaCanchaUS} type="checkbox" checked={canchaActivaUS} onChange={(e) => {clickGenerico("MODIFICAR_ESTADO_CANCHA")}}/><span className="IP_slider round"></span>
                                    </label>
                                </div>
                            </div>
                    </div>*/
                    }

                    {/* ZONA DATOS CANCHA */} 
                    <div style={{flex:"1", display:"block", justifyContent:"center", textAlign:"left", maxWidth:"800px", marginTop:"20px"}}>
                                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                                        <div style={{width:"100px"}}>Número:</div>
                                        <div style={{minWidth:"100px", maxWidth: "150px", color:C_uniformeGrisMedio, fontWeight:"bolder"}}>{arrCampos[0].valor}</div>                                          
                                    </div>                                    

                                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", marginTop:"10px"}}>
                                        <div style={{width:"100px"}}>Nombre:</div>
                                        <input type="text" value={arrCampos[1].valor} className='IP_entradas' style={{flex:"1", flexGrow: 1, flexShrink: 1, minWidth:"100px", maxWidth: "250px", paddingInline:"6px"}} placeholder="" onChange={(e) => validarCampo(e, "NOMBRE", 20)} onBlur={(e) => clickGenerico("SALE_NOMBRE")}/>   
                                        <img className='IM_imgIcono28' src={ic_transparente} alt='' style={{paddingLeft:"10px"}} />
                                    </div>
                                    {arrCampos[1].error!==""  && (<div style={{marginLeft:"100px"}}><span className="TX_error">{arrCampos[1].error}</span></div>)}

                                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", marginTop:"10px"}}>
                                        <div style={{width:"100px"}}>Ubicación:</div>
                                        <div className='IP_entradas2' style={{flex:"1", flexGrow: 1, flexShrink: 1, minWidth:"100px", maxWidth: "250px", whiteSpace:"pre", overflow:"hidden"}}>{arrCampos[3].valor}</div>   
                                        <img className='IM_imgIcono28' src={ic_ubicacion_verde} alt='' style={{paddingLeft:"10px", cursor:"pointer"}} onClick={() => {openMapa()}}/>
                                    </div>

                    </div>

                    {/* ZONA TORNEOS Y CANCHAS UNIDAS */}         
                    <div style={{display:"flex", flexWrap:"wrap", gap:"20px", justifyContent:"left", alignItems:"start", maxWidth:"800px", marginTop:"20px"}}>

                        {/* ZONA CANCHAS UNIDAS */} 
                        <div style={{flex:"1", flexGrow:"1", flexShrink:"1", minWidth:"250px", maxWidth:"500px", alignItems:"center"}}>

                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                                <div style={{flex:"1", marginRight:"10px",textAlign:"left", fontSize:"14px"}}>Esta Cancha esta integrada por otras canchas en la sede?</div>
                                <div style={{display:"flex", justifyContent:"right", alignItems:"center", height:"20px", marginRight:"10px"}}>
                                    <p>NO</p>
                                    <label className="switch">
                                        <input type="checkbox" checked={esCanchaUnidaUS} onChange={(e) => {clickGenerico("CAMBIAR_CHECK_CANCHA_UNIDA",e)}}/><span className="slider round"></span>
                                    </label>
                                    <p>SI</p>
                                </div>
                            </div>

                            <div style={{fontSize:"12px", color:C_uniformeGrisOscuro, textAlign:"left", whiteSpace:"pre-line", marginTop:"10px"}}>
                                {"Este tipo de canchas se utilizan cuando un grupo de canchas se unen para formar una cancha mas grande. Ejemplo: 3 canchas de F5 se unen para formar una cancha de F7 o F8" +
                                "\n\nCon esta configuración MarcaGol administrará la cancha que esta creando asi como las canchas unidas, para evitar que se programen partidos simultaneamente en estas."}
                            </div>

                            {esCanchaUnidaUS && (
                                <div className='BF_cajaAccent' style={{minWidth:"250px", maxWidth:"500px", flexGrow:"1", flexShrink:"1", marginTop:"20px"}}>
                                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>                                         
                                        <p className='TX_tituloCaja' style={{flex:"1"}}>{"Canchas Unidas"}</p> 
                                        <img className='IM_imgIcono28' style={{padding:"4px", cursor:"pointer"}} src={ic_detalle_blanco} alt='' onClick={() => {abrirVentanaBusqueda();}}/> 
                                    </div>

                                    <div className='BF_cajaBlanca'>                                        
                                        {canchasUnidasUS.length>0 && (<> 
                                            {(canchasUnidasUS.map((reg, index) => (<DinamicoElementosTorneo key={index} registro={index} numRegistro={index+1} tipoLista={"CANCHAS_UNIDAS"} datos={reg} definirModulo={clickGenerico} incluirLinea={true}  />))  )}     
                                        </>)}  
                                        {canchasUnidasUS.length===0 && (
                                            <div className="TX_sinInfo" style={{margin:"10px"}}>{"No ha incluido canchas"}</div>
                                        )}                                        
                                    </div>
                                </div>
                            )}                    

                                                       
                        </div>

                        {/* ZONA TORNEOS ACTIVOS */} 
                        {!nuevaCanchaUS && (
                            <div style={{flex:"1", display:"flex", flexWrap:"wrap", flexGrow:"1", flexShrink:"1", minWidth:"250px", maxWidth:"500px", gap:"20px"}}>
                                                        

                            {true && (
                                <div className='BF_cajaGris' style={{minWidth:"250px", maxWidth:"500px", flexGrow:"1", flexShrink:"1", }}>
                                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}> 
                                        <p className='TX_tituloCaja' style={{flex:"1"}}>{"Torneos Activos"}</p> 
                                    </div>

                                    <div className='BF_cajaBlanca'> <div></div> 
                                        
                                        {torneosCanchaUS.length>0 && (<> 
                                            {(torneosCanchaUS.map((reg, index) => (<DinamicoElementosTorneo key={index} registro={index} numRegistro={index+1} tipoLista={"TORNEOS_ACTIVOS_CANCHA"} datos={reg} definirModulo={clickGenerico} incluirLinea={false} />))  )}     
                                        </>)}  
                                        {torneosCanchaUS.length===0 && (
                                            <div className="TX_sinInfo" style={{margin:"10px"}}>{"Esta cancha no esta asignada a Torneos Activos"}</div>
                                        )}
                                                                                    
                                    </div>
                                </div>
                            )}
                            

                            </div>
                        )}
                        
                    </div>

                </div>


                {/* BARRA INFERIOR DE OPCIONES CANCHA NUEVA DESDE TORNEO*/} 
                {!showFullUS && (
                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", padding:"8px", background: C_colorPrimaryDark, color: C_uniformeBlanco}} >                
                        <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center", cursor:"pointer"}} onClick={() => {definirModulo("CLICK_CANCELAR_NUEVA_CANCHA")}}>
                                <img src={ic_cancelar_gris} className="IM_imgIcono24" alt="" style={{margin:"0px", padding:"0px"}}/>
                                <span className='TX_unaSolaLinea2' style={{marginLeft:"8px", color:C_uniformeBlanco} }>Cancelar</span>
                        </div> 
                        <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center", cursor:"pointer"}} onClick={() => {clickGenerico("CLICK_CREAR_NUEVA_CANCHA")}}>
                                <img src={ic_ok} className="IM_imgIcono24" alt="" style={{margin:"0px", padding:"0px"}}/>
                                <span className='TX_unaSolaLinea2' style={{marginLeft:"8px", color:C_uniformeBlanco} }>Crear</span>
                        </div> 
                    </div>  
                )}


                {/* BARRA INFERIOR DE OPCIONES CANCHA NUEVA*/} 
                {showFullUS && nuevaCanchaUS && (
                 <div className='CT_zonaFijaInferior' style={{display:"flex", flexWrap:"nowrap", alignItems:"center", padding:"8px"}} >                
                    <div style={{flex:"1"}}> </div>
                    <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center", cursor:"pointer"}} onClick={() => {clickGenerico("CLICK_CREAR_NUEVA_CANCHA")}}>
                            <img src={ic_ok} className="IM_imgIcono24" alt="" style={{margin:"0px", padding:"0px"}}/>
                            <span className='TX_unaSolaLinea2' style={{marginLeft:"8px", color:C_uniformeBlanco} }>Crear</span>
                    </div> 
                </div>   
                )}

                {/* BARRA INFERIOR DE OPCIONES CANCHA EXISTENTE*/} 
                {showFullUS && !nuevaCanchaUS && (
                 <div className='CT_zonaFijaInferior' style={{display:"flex", flexWrap:"nowrap", alignItems:"center", padding:"8px"}} >                     
                    <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center", cursor:"pointer"}} onClick={() => {clickGenerico("MODIFICAR_ESTADO_CANCHA")}}>
                            <img src={canchaActivaUS ? ic_inactivo : ic_activo} className="IM_imgIcono24" alt="" style={{margin:"0px", padding:"0px"}}/>
                            <span className='TX_unaSolaLinea2' style={{marginLeft:"8px", color:C_uniformeBlanco} }>{canchaActivaUS ? "Inactivar" : "Activar"}</span>
                    </div> 
                    {tienePartidosUS ? (<div style={{flex:"1"}}> </div>) : (
                        <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center", cursor:"pointer"}} onClick={() => {clickGenerico("CLICK_BORRAR_CANCHA")}}>
                            <img src={ic_borrar_blanco} className="IM_imgIcono24" alt="" style={{margin:"0px", padding:"0px"}}/>
                            <span className='TX_unaSolaLinea2' style={{marginLeft:"8px", color:C_uniformeBlanco} }>{"Borrar"}</span>
                        </div> 
                    )}
                    
                    <div style={{flex:"1"}}> </div>
                </div>   
                )}

            </>)}
                
           

            {esError!==0 && <ShowError tipoError={esError} funcionCerrar={salir} />}

            {loading && <Loader tipo={"TOTAL"}/>}   
        </>
    );

};

export default Admin_Canchas;